<template>
  <div v-model="topbar">
    <div class="mobile-view bg-black p-t-15 p-lr-15">
      <v-row class="p-lr-5">
        <v-col cols="8">
          <v-img :src="logo" width="32%" contain class="m-b-10" />
          <h1 class="white-text font-xl bold">{{ title }}</h1>
        </v-col>
        <v-col cols="4" class="white-text right header-icon-wrapper">
          <div @click="readNotification()" class="notification-icon">
            <i class="fa fa-bell m-r-10 font-nm"></i>
            <span v-if="counter"  class="notification-icon-circle yellow-text">
              <i class="fas fa-circle"></i>
              <span>{{ counter }}</span>
            </span>
          </div>
          <i v-on:click="emitOpenDrawer" class="fas fa-user font-xs profile-icon gradient-blue white-text"></i>
        </v-col>
      </v-row>
    </div>

    <div class="desktop-view desktop-header-wrapper gradient-black">
      <v-row class="desktop-header-inner">
        <v-col cols="2">
          <v-img :src="logo" width="130px" class="m-t-15" contain />
        </v-col>
        <v-col cols="10" class="white-text right header-icon-wrapper">
          <div class="notification-icon m-r-20">
            <i class="fa fa-bell m-r-10 font-md" @click="readNotification()"></i>
            <span v-if="counter"  class="notification-icon-circle yellow-text">
              <i class="fas fa-circle"></i>
              <span>{{ counter }}</span>
            </span>
          </div>
          <div class="desktop-language m-r-30">
            <img
                    src="@/assets/language/flag-en.svg"
                    alt="John"
                    width="25px"
                    class="m-r-10"
            >
            <v-select
                    :items="language"
                    standard
                    dense
                    dark
                    value="EN"
            ></v-select>
          </div>
          <div class="text-center m-r-20">
            <h1 v-if="member" class="m-b-5 font-xl white-text">{{ member.available_balance }} {{ currency }}</h1>
            <h1 v-else class="m-b-5 font-xl white-text">0.00 {{ currency }}</h1>
            <p class="gray-text font-sm">Withdrawable Balance</p>
          </div>
          <div class="balance-divider text-center p-l-20 m-r-20">
            <h1 v-if="member" class="m-b-5 font-xl white-text">{{ member.preferences.runningRevenueShare }} {{ currency }}</h1>
            <h1 v-else class="m-b-5 font-xl white-text">0.00 {{ currency }}</h1>
            <p class="gray-text font-sm">Running Revenue Share</p>
          </div>
          <v-menu offset-y
                  id="profileMenu"
          >
            <template v-slot:activator="{ on }">
              <v-avatar
                v-on="on"
                class="gradient-blue">
                <i class="fas fa-user font-md white-text"></i>
              </v-avatar>
            </template>
            <v-list class="m-t-5 p-t-20 p-r-15 p-l-15 text-center">
              <h4 class="font-lg" v-if="member">{{ member.full_name }}</h4>
              <span class="gray-text font-sm m-t-3" v-if="member">{{ member.user.email }}</span>
              <v-list-item
                :to="{ name: 'settings' }"
                class="m-t-5"
              >
                <v-list-item-title class="font-nm"><i class="fas fa-cog gray-text m-r-5"></i> Settings</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="logout()"
              >
                <v-list-item-title class="font-nm"><i class="fas fa-sign-out-alt gray-text m-r-5"></i> Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import storage from "../../utility/storage";

export default {
  name: "TopBar",
  data() {
    return {
      member: '',
      currency: 'EUR',
      topbar: true,
      drawer: true,
      logo: require('@/assets/piwi-logo.svg'),
      counter: 0,
      language: ['EN'],
      on: {},
    }
  },
  methods: {
    emitOpenDrawer (event) {
      this.$emit('openDrawer', this.drawer)
    },
    countNotification (data) {
      let count = 0
      let notif = data

      if (data === null || !data.length) {
        notif = storage.getObject('notifications')
      }

      if (notif !== null) {
        for (let value of notif) {
          if (value !== null && !value.read) {
            count++
          }
        }
      }

      this.counter = count
    },
    readNotification() {
      this.$router.push('/notification')
      if (this.counter !== 0) {
        this.$store.dispatch('member/readNotification')
      }
    },
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'auth-login' })
      })
    }
  },
  props: {
    title: String
  },
  computed: {
    ...mapGetters('member', ['notifications']),
  },
  watch: {
    notifications (value) {
      this.countNotification(value)
    }
  },
  mounted() {
    this.countNotification([])
    setTimeout(() => {
      this.member = JSON.parse(localStorage.getItem('member'))
    }, 1000)
  }
}
</script>

<style scoped></style>